import auth from "@/components/auth/Auth";
import login from "@/components/auth/Login";
import forgotPassword from "@/components/auth/ForgotPassword";
import forgotPasswordReset from "@/components/auth/ForgotPasswordReset";

export default {
  path: "/auth",
  component: auth,
  meta: {
    permission: "any"
  },
  children: [
    {
      path: "login",
      name: "login",
      component: login,
      meta: {
        title: "Login",
        permission: "any"
      }
    },
    {
      path: "forgot-password",
      name: "forgot-password",
      component: forgotPassword,
      meta: {
        title: "Forgot Password",
        permission: "any"
      }
    },
    {
      path: "forgot-password-reset",
      name: "forgot-password-reset",
      component: forgotPasswordReset,
      meta: {
        title: "Forgot Password Reset",
        permission: "any"
      }
    }
  ]
};
